<template>
  <div style="padding:20px;">
    <el-row>
      <el-col :span="24">
        <el-button
            style="padding: 0; margin: 20px"
            type="text"
            icon="el-icon-back"
            @click="backPrePage()"
        >
          返回
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-form ref="form" :model="form" label-width="150px" :disabled="formLoading">
        <h2>色号设置</h2>
        <el-row>
          <el-col :span="6">
            <el-form-item label="页面背景色号">
              <el-input size="medium" v-model="form.background_color" style="width:100px"></el-input>
              <i class="el-icon-picture-outline" :style="{background:form.background_color,lineHeight:'36px',width:'36px', textAlign:'center',marginLeft:'10px',color:'#ffffff'}"></i>
            </el-form-item>
            <el-form-item label="领券按钮色号">
              <el-input size="medium" v-model="form.receive_coupon_button" style="width:100px"></el-input>
              <i class="el-icon-picture-outline" :style="{background:form.receive_coupon_button,lineHeight:'36px',width:'36px', textAlign:'center',marginLeft:'10px',color:'#ffffff'}"></i>
            </el-form-item>
            <el-form-item label="课程列表“查看更多”按钮色号">
              <el-input size="medium" v-model="form.course_list_button" style="width:100px"></el-input>
              <i class="el-icon-picture-outline" :style="{background:form.course_list_button,lineHeight:'36px',width:'36px', textAlign:'center',marginLeft:'10px',color:'#ffffff'}"></i>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="会员按钮色号">
              <el-input size="medium" v-model="form.vip_button" style="width:100px"></el-input>
              <i class="el-icon-picture-outline" :style="{background:form.vip_button,lineHeight:'36px',width:'36px', textAlign:'center',marginLeft:'10px',color:'#ffffff'}"></i>
            </el-form-item>
            <el-form-item label="会员支付角标色号">
              <el-input size="medium" v-model="form.vip_button_tag" style="width:100px"></el-input>
              <i class="el-icon-picture-outline" :style="{background:form.vip_button_tag,lineHeight:'36px',width:'36px', textAlign:'center',marginLeft:'10px',color:'#ffffff'}"></i>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="主推课按钮色号">
              <el-input size="medium" v-model="form.main_course_button" style="width:100px"></el-input>
              <i class="el-icon-picture-outline" :style="{background:form.main_course_button,lineHeight:'36px',width:'36px', textAlign:'center',marginLeft:'10px',color:'#ffffff'}"></i>
            </el-form-item>
            <el-form-item label="主推课倒计时背景">
              <el-input size="medium" v-model="form.main_course_time" style="width:100px"></el-input>
              <i class="el-icon-picture-outline" :style="{background:form.main_course_time,lineHeight:'36px',width:'36px', textAlign:'center',marginLeft:'10px',color:'#ffffff'}"></i>
            </el-form-item>
          </el-col>
        </el-row>

        <h2>头图设置</h2>
        <el-row>
          <el-col :span="6">
            <el-form-item label="主题背景图" >750*840
              <activityCustomUpload :formName="'background_image'" :formValue="form.background_image" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="优惠券遮罩" >750*420
              <activityCustomUpload :formName="'coupon_mask'" :formValue="form.coupon_mask" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider></el-divider>

        <h2>直播间设置</h2>
        <el-row>
          <el-col :span="6">
            <el-form-item label="直播间背景图" >700*700
              <activityCustomUpload :formName="'live_background_image'" :formValue="form.live_background_image" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider></el-divider>

        <h2>主推课价格区主题图设置</h2>
        <el-row>
          <el-col :span="12">
            <el-form-item label="价格区主题图" >700*120 提示：该区域上传后请检查前端活动页显示效果
              <activityCustomUpload :formName="'main_courses_price_image'" :formValue="form.main_courses_price_image" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider></el-divider>

        <h2>主推课横图设置</h2>
        <el-row>
          <el-col :span="6">
            <el-form-item label="线下主推课横图" >700*140
              <activityCustomUpload :formName="'offline_main_course_list_horizontal'" :formValue="form.offline_main_course_list_horizontal" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="线上主推课横图" >700*140
              <activityCustomUpload :formName="'online_main_course_list_horizontal'" :formValue="form.online_main_course_list_horizontal" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider></el-divider>

        <h2>线下主推课主图</h2>
        <el-row>
          <el-col :span="24">
            <template v-for="(item,index) in form.offline_main_course_list_imgs">
              <el-col :span="6" v-bind:key="index">
                <el-form-item :label="'线下主推课主图' + (index+1)" >700*420
                  <activityCustomUpload :formName="'url_' + index" :formValue="item" @uploadSuccess="uploadSuccess2"></activityCustomUpload>
                </el-form-item>
              </el-col>
            </template>
          </el-col>
          <el-col :span="24">
            <el-button @click="form.offline_main_course_list_imgs.push('')" type="primary" icon="el-icon-plus" size="medium">增加
            </el-button>
          </el-col>
        </el-row>
        
        <el-divider></el-divider>

        <h2>线上主推课主图</h2>
        <el-row>
          <el-col :span="24">
            <template v-for="(item,index) in form.online_main_course_list_imgs">
              <el-col :span="6" v-bind:key="index">
                <el-form-item :label="'线上主推课主图' + (index+1)" >700*420
                  <activityCustomUpload :formName="'url_' + index" :formValue="item" @uploadSuccess="uploadSuccess"></activityCustomUpload>
                </el-form-item>
              </el-col>
            </template>
          </el-col>
          <el-col :span="24">
            <el-button @click="form.online_main_course_list_imgs.push('')" type="primary" icon="el-icon-plus" size="medium">增加
            </el-button>
          </el-col>
        </el-row>
        
        <el-divider></el-divider>
        
        <h2>秒杀课程列表设置</h2>
        <el-row>
          <el-col :span="6">
            <el-form-item label="课程列表模块横图" >700*140
              <activityCustomUpload :formName="'flash_course_list_horizontal'" :formValue="form.flash_course_list_horizontal" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider></el-divider>

        <h2>券后价课程列表设置</h2>
        <el-row>
          <el-col :span="6">
            <el-form-item label="课程列表模块横图" >700*140
              <activityCustomUpload :formName="'courses_list_image'" :formValue="form.courses_list_image" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="活动角标" >70*42
              <activityCustomUpload :formName="'activity_marker_image'" :formValue="form.activity_marker_image" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider></el-divider>

        <h2>会员模块设置</h2>
        <el-row>
          <el-col :span="6">
            <el-form-item label="会员模块横图" >700*140
              <activityCustomUpload :formName="'vip_image'" :formValue="form.vip_image" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="会员促销图" >700*140
              <activityCustomUpload :formName="'vip_sell_image'" :formValue="form.vip_sell_image" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider></el-divider>

        <h2>电商模块设置</h2>
        <el-row>
          <el-col :span="6">
            <el-form-item label="电商模块横图" >700*140
              <activityCustomUpload :formName="'product_image'" :formValue="form.product_image" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider></el-divider>

        <h2>悬浮按钮设置</h2>
        <el-row>
          <el-col :span="6">
            <el-form-item label="回到顶部图标" >120*120
              <activityCustomUpload :formName="'icon_top'" :formValue="form.icon_top" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="生成海报图标" >120*120
              <activityCustomUpload :formName="'icon_share'" :formValue="form.icon_share" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="导流图标1" >120*120
              <activityCustomUpload :formName="'icon_guide_1'" :formValue="form.icon_guide_1" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
            <el-form-item label="导流链接1">
              <el-input size="medium" v-model="form.link_guide_1" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="导流图标2" >120*120
              <activityCustomUpload :formName="'icon_guide_2'" :formValue="form.icon_guide_2" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
            <el-form-item label="导流链接2">
              <el-input size="medium" v-model="form.link_guide_2" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider></el-divider>

        <h2>分享海报设置</h2>
        <el-row>
          <el-col :span="6">
            <el-form-item label="分享海报模板1" >750*1334
              <activityCustomUpload :formName="'share_image1'" :formValue="form.share_image1" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="分享海报模板2" >750*1334
              <activityCustomUpload :formName="'share_image2'" :formValue="form.share_image2" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="分享海报模板3" >750*1334
              <activityCustomUpload :formName="'share_image3'" :formValue="form.share_image3" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="分享海报模板4" >750*1334
              <activityCustomUpload :formName="'share_image4'" :formValue="form.share_image4" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="分享海报模板5" >750*1334
              <activityCustomUpload :formName="'share_image5'" :formValue="form.share_image5" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="分享海报模板6" >750*1334
              <activityCustomUpload :formName="'share_image6'" :formValue="form.share_image6" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="分享海报模板7" >750*1334
              <activityCustomUpload :formName="'share_image7'" :formValue="form.share_image7" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="分享海报模板8" >750*1334
              <activityCustomUpload :formName="'share_image8'" :formValue="form.share_image8" @uploadSuccess="uploadSuccess"></activityCustomUpload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider></el-divider>

        <el-form-item>
          <el-button type="primary" :loading="onSaveLoading" @click="onSave">保存</el-button>
         <el-button @click="backPrePage()">取消</el-button>
        </el-form-item>
      </el-form>
    </el-row>
  </div>
</template>
<script>
import activityCustomUpload from "@/components/activityCustomUpload.vue";
import {
  getInfo, savePageElementInfo
} from "@/api/activityCustom";

export default {
  components: { activityCustomUpload },
  data: function () {
    return {
      id: '',
      info: {},
      form: {
        background_color:'',
        background_image:'',
        coupon_mask:'',
        live_background_image:'',
        main_courses_image:'',
        courses_list_image:'',
        activity_marker_image:'',
        vip_image:'',
        vip_sell_image:'',
        product_image:'',
        share_image1:'',
        share_image2:'',
        share_image3:'',
        share_image4:'',
        share_image5:'',
        share_image6:'',
        share_image7:'',
        share_image8:'',
        receive_coupon_button:'',
        main_course_button:'',
        vip_button:'',
        vip_button_tag:'',
        course_list_button:'',
        icon_share:'',
        icon_top:'',
        icon_guide_1:'',
        link_guide_1:'',
        icon_guide_2:'',
        link_guide_2:'',
        main_courses:'',
        online_main_course_list_imgs:[],
        offline_main_course_list_imgs:[],
      },
      ossAction: "",
      formLoading: false,
      onSaveLoading: false,
    }
  },
  created: function () {
    this.id = this.$route.query.id;
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.formLoading = true;
      getInfo({
        id: this.id
      }).then(response => {
        this.formLoading = false
        this.info = response.data
        this.form = response.data.page_element;

        if(typeof this.form.online_main_course_list_imgs == 'undefined'){
          this.$set(this.form, 'online_main_course_list_imgs', [''])
        }
        if(typeof this.form.offline_main_course_list_imgs == 'undefined'){
          this.$set(this.form, 'offline_main_course_list_imgs', [''])
        }
      });
    },
    uploadSuccess(value){
      let temp = value.formName.split('_');
      if (temp[0] == 'url') {
        if(value.fileUrl == ''){
          this.$delete(this.form.online_main_course_list_imgs, temp[1])
        }else{
          this.$set(this.form.online_main_course_list_imgs, temp[1], value.fileUrl)
        }
      } else {
        this.$set(this.form, value.formName, value.fileUrl)
      }
    },
    uploadSuccess2(value){
      let temp = value.formName.split('_');
      if (temp[0] == 'url') {
        if(value.fileUrl == ''){
          this.$delete(this.form.offline_main_course_list_imgs, temp[1])
        }else{
          this.$set(this.form.offline_main_course_list_imgs, temp[1], value.fileUrl)
        }
      } else {
        this.$set(this.form, value.formName, value.fileUrl)
      }
    },
    onSave(){
      this.onSaveLoading = true;
      let that = this
      savePageElementInfo({
        id: this.id,
        form: this.form
      }).then(res => {
        that.onSaveLoading = false;
        if(res.code == 1){
          that.$message({
            showClose: true,
            duration: 6000,
            message: '保存成功',
            type: 'success'
          });
          that.backPrePage();
        }
      });
    },
    backPrePage(){
      this.$router.go(-1);
    }
  },
}
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  min-height: 70px;
  line-height: 70px;
  text-align: center;
}
.avatar {
  width: 100px;
  min-height: 40px;
  display: block;
}
h1{
  margin-bottom: 15px;
}
</style>